import { forwardRef } from "react";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";

export const Alert = forwardRef((props: AlertProps, ref) => {
  return <MuiAlert elevation={6} variant="filled" {...props} ref={ref} />;
});
